var map = {
	"./CRC_NA_Logo.jpeg": 6412,
	"./ClimateARM_300.jpg": 8684,
	"./CropARM_300.jpg": 3837,
	"./FDF_ARMonline_projectFlyer.pdf": 4467,
	"./FallowARM_300.jpg": 9036,
	"./FieldIcon.png": 2764,
	"./Keith_profile_photo.png": 7421,
	"./Logo_FDF.png": 3215,
	"./NewItem.png": 5164,
	"./PersonaliedCroppingDecisions_Booklet_250320.pdf": 2692,
	"./PersonaliedCroppingDecisions_Presentation_websiteUpload.pdf": 9270,
	"./Ploughed_field.png": 2128,
	"./Rotation_300.png": 6339,
	"./Tractor_Ploughing.png": 448,
	"./UniTas_logo.svg": 8523,
	"./Video.png": 1258,
	"./Workshops.png": 153,
	"./aust_gov_stacked.png": 1623,
	"./imgDeepP.jpg": 1502,
	"./plant_gr.png": 6578,
	"./plant_wh.png": 8040,
	"./qg_logo_mar.png": 2328,
	"./round_FieldIcon.png": 2697,
	"./round_Workshop.png": 8519,
	"./traffic_cone.jpeg": 7789,
	"./usq-logo-black.png": 7886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;